export default __webpack_public_path__ + "images/news/carraro_7600_2.jpg";